import React from 'react';
import './AboutPage.scss'; // Modular SCSS import for About page
import AboutHeader from '../sections/AboutHeader/AboutHeader';
import AboutStory from '../sections/AboutStory/AboutStory';
import AboutTeam from '../sections/AboutTeam/AboutTeam';
import AboutStats from '../sections/AboutStats/AboutStats';

const AboutPage = () => {
  return (
    <>
      <AboutHeader />
      <AboutStory />
      <AboutTeam />
      <AboutStats />
    </>
  );
};

export default AboutPage;
